module.exports = __webpack_public_path__ + "8492f974871ab6d9650ef3f66ba6a2ea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-3.png
// module id = 2676
// module chunks = 0